import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function ArticlePage() {
  return (
    <>
      <Navbar />
      <main>
        <article className="pt-24 pb-16 md:pb-20">
          <div className="px-4 md:px-6 max-w-[800px] mx-auto">
            <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-foreground-900 cursor-pointer transition-colors">Home</Link>
              <span className="mx-2">/</span>
              <span className="text-foreground-700 font-medium">Guida Completa Itaobuy Spreadsheet</span>
            </nav>

            <header className="mb-10">
              <span className="text-xs font-semibold uppercase tracking-wider text-primary-600">Guida per Principianti</span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-tight">
                Guida Completa a Itaobuy Spreadsheet: Come Trovare i Migliori Prodotti Cinesi nel 2026
              </h1>
              <div className="flex flex-wrap items-center gap-4 mt-4 text-xs text-foreground-500">
                <span>Pubblicato: Gennaio 2026</span>
                <span>|</span>
                <span>Ultimo aggiornamento: Luglio 2026</span>
                <span>|</span>
                <span>Tempo di lettura: 12 minuti</span>
              </div>
            </header>

            <div className="prose-custom">
              <div className="bg-primary-50 border-l-4 border-primary-400 p-4 md:p-5 rounded-r-lg mb-8">
                <p className="text-sm font-medium text-primary-800">
                  <strong>Definizione rapida:</strong> Itaobuy Spreadsheet è una raccolta organizzata di prodotti selezionati dai marketplace cinesi come Taobao e Weidian. Si tratta di un foglio di calcolo curato manualmente che cataloga centinaia di articoli verificati con foto reali (QC Photos), link diretti, valutazioni di qualità e prezzi aggiornati, permettendo agli utenti italiani di scoprire e acquistare prodotti di tendenza senza perdersi nella complessità dei siti originali cinesi.
                </p>
              </div>

              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">Cos&apos;è Itaobuy Spreadsheet</h2>
              <p className="text-foreground-700 leading-relaxed mb-4">
                Itaobuy Spreadsheet rappresenta una rivoluzione nel modo in cui gli acquirenti italiani scoprono i prodotti 
                dai marketplace cinesi. Nato dall&apos;esigenza di organizzare e catalogare i migliori ritrovamenti su 
                <strong> Taobao</strong>, <strong>Weidian</strong> e altri marketplace cinesi, questo strumento si è evoluto 
                fino a diventare il punto di riferimento per migliaia di appassionati di shopping internazionale.
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                A differenza della navigazione diretta sui siti cinesi — spesso complessa, in lingua mandarina e con 
                interfacce poco intuitive — Itaobuy Spreadsheet offre un&apos;esperienza ordinata e accessibile. 
                Ogni prodotto è accompagnato da una descrizione chiara in italiano, foto QC che mostrano l&apos;aspetto 
                reale dell&apos;articolo (non le foto promozionali del venditore), e un link diretto per l&apos;acquisto.
              </p>

              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">Come Funziona Itaobuy Spreadsheet</h2>
              <p className="text-foreground-700 leading-relaxed mb-4">
                Il funzionamento di Itaobuy Spreadsheet è sorprendentemente semplice, anche per chi non ha mai 
                acquistato dalla Cina. Ecco i passaggi fondamentali:
              </p>
              <div className="bg-background-100 rounded-xl p-5 md:p-6 mb-6">
                <ol className="space-y-4">
                  <li className="flex gap-3">
                    <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">1</span>
                    <div>
                      <strong className="text-foreground-900">Sfoglia le Categorie</strong>
                      <p className="text-sm text-foreground-600 mt-1">Naviga tra le 14 categorie disponibili sul nostro portale: Scarpe, Felpe, T-Shirt, Giacche, Pantaloni, Accessori e molto altro. Ogni categoria contiene decine di prodotti verificati.</p>
                    </div>
                  </li>
                  <li className="flex gap-3">
                    <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">2</span>
                    <div>
                      <strong className="text-foreground-900">Accedi allo Spreadsheet</strong>
                      <p className="text-sm text-foreground-600 mt-1">Clicca sul link della categoria per accedere direttamente allo spreadsheet su Kaspreadsheet. Qui troverai tutte le informazioni dettagliate: foto QC, taglie, prezzi e link originale del venditore.</p>
                    </div>
                  </li>
                  <li className="flex gap-3">
                    <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">3</span>
                    <div>
                      <strong className="text-foreground-900">Scegli un Agent di Shipping</strong>
                      <p className="text-sm text-foreground-600 mt-1">Utilizza un agent di shipping affidabile per acquistare i prodotti. L&apos;agent riceverà il pacco nel suo magazzino cinese, scatterà le foto QC, e spedirà tutto in Italia con il metodo che preferisci.</p>
                    </div>
                  </li>
                  <li className="flex gap-3">
                    <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">4</span>
                    <div>
                      <strong className="text-foreground-900">Ricevi e Goditi i Tuoi Acquisti</strong>
                      <p className="text-sm text-foreground-600 mt-1">Dopo la conferma delle foto QC, l&apos;agent spedisce il pacco in Italia. I tempi variano da 5 a 30 giorni in base al metodo di spedizione scelto.</p>
                    </div>
                  </li>
                </ol>
              </div>

              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">Vantaggi di Itaobuy Spreadsheet</h2>
              <div className="overflow-x-auto mb-8">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="bg-background-100">
                      <th className="text-left p-3 font-semibold text-foreground-900 border-b border-background-200">Caratteristica</th>
                      <th className="text-left p-3 font-semibold text-foreground-900 border-b border-background-200">Itaobuy Spreadsheet</th>
                      <th className="text-left p-3 font-semibold text-foreground-900 border-b border-background-200">Navigazione Diretta</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Lingua</td>
                      <td className="p-3 text-primary-700 font-medium border-b border-background-200">Italiano</td>
                      <td className="p-3 text-foreground-500 border-b border-background-200">Cinese (difficile)</td>
                    </tr>
                    <tr>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Prodotti Verificati</td>
                      <td className="p-3 text-primary-700 font-medium border-b border-background-200">Sì, con foto QC</td>
                      <td className="p-3 text-foreground-500 border-b border-background-200">No, foto promozionali</td>
                    </tr>
                    <tr>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Organizzazione</td>
                      <td className="p-3 text-primary-700 font-medium border-b border-background-200">14 categorie chiare</td>
                      <td className="p-3 text-foreground-500 border-b border-background-200">Caotica</td>
                    </tr>
                    <tr>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Prezzi</td>
                      <td className="p-3 text-primary-700 font-medium border-b border-background-200">Aggiornati regolarmente</td>
                      <td className="p-3 text-foreground-500 border-b border-background-200">Variabili, difficili da confrontare</td>
                    </tr>
                    <tr>
                      <td className="p-3 text-foreground-700">Guide e Supporto</td>
                      <td className="p-3 text-primary-700 font-medium">Guide complete in italiano</td>
                      <td className="p-3 text-foreground-500">Nessuna guida</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">Prodotti Più Popolari su Itaobuy Spreadsheet</h2>
              <p className="text-foreground-700 leading-relaxed mb-4">
                Ecco una panoramica dei prodotti più ricercati dagli utenti italiani nel nostro spreadsheet:
              </p>
              <div className="overflow-x-auto mb-8">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="bg-background-100">
                      <th className="text-left p-3 font-semibold text-foreground-900 border-b border-background-200">Prodotto</th>
                      <th className="text-left p-3 font-semibold text-foreground-900 border-b border-background-200">Categoria</th>
                      <th className="text-left p-3 font-semibold text-foreground-900 border-b border-background-200">Fascia Prezzo</th>
                      <th className="text-left p-3 font-semibold text-foreground-900 border-b border-background-200">Qualità</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Sneakers Designer</td>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Scarpe</td>
                      <td className="p-3 text-foreground-700 border-b border-background-200">€30 - €80</td>
                      <td className="p-3 text-accent-600 font-medium border-b border-background-200">Alta ★★★★★</td>
                    </tr>
                    <tr>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Felpe con Cappuccio</td>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Felpe</td>
                      <td className="p-3 text-foreground-700 border-b border-background-200">€15 - €40</td>
                      <td className="p-3 text-accent-600 font-medium border-b border-background-200">Alta ★★★★☆</td>
                    </tr>
                    <tr>
                      <td className="p-3 text-foreground-700 border-b border-background-200">T-Shirt Grafiche</td>
                      <td className="p-3 text-foreground-700 border-b border-background-200">T-Shirt</td>
                      <td className="p-3 text-foreground-700 border-b border-background-200">€8 - €20</td>
                      <td className="p-3 text-accent-600 font-medium border-b border-background-200">Media ★★★☆☆</td>
                    </tr>
                    <tr>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Giacche Tecniche</td>
                      <td className="p-3 text-foreground-700 border-b border-background-200">Giacche</td>
                      <td className="p-3 text-foreground-700 border-b border-background-200">€40 - €100</td>
                      <td className="p-3 text-accent-600 font-medium border-b border-background-200">Alta ★★★★★</td>
                    </tr>
                    <tr>
                      <td className="p-3 text-foreground-700">Maglie da Calcio</td>
                      <td className="p-3 text-foreground-700">Maglie Sportive</td>
                      <td className="p-3 text-foreground-700">€12 - €25</td>
                      <td className="p-3 text-accent-600 font-medium">Alta ★★★★☆</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">È Sicuro Acquistare con Itaobuy Spreadsheet?</h2>
              <div className="flex flex-col md:flex-row gap-6 mb-8">
                <div className="flex-1 bg-primary-50 rounded-xl p-5">
                  <h3 className="font-semibold text-primary-800 mb-2 flex items-center gap-2">
                    <i className="ri-check-line text-primary-600"></i> Vantaggi
                  </h3>
                  <ul className="space-y-2 text-sm text-primary-700">
                    <li>• Prodotti verificati con foto reali (QC Photos)</li>
                    <li>• Venditori controllati per affidabilità</li>
                    <li>• Prezzi trasparenti e aggiornati</li>
                    <li>• Guide complete in italiano</li>
                    <li>• Agent di shipping affidabili</li>
                    <li>• Comunità attiva di acquirenti italiani</li>
                  </ul>
                </div>
                <div className="flex-1 bg-accent-50 rounded-xl p-5">
                  <h3 className="font-semibold text-accent-800 mb-2 flex items-center gap-2">
                    <i className="ri-alert-line text-accent-600"></i> A Cosa Fare Attenzione
                  </h3>
                  <ul className="space-y-2 text-sm text-accent-700">
                    <li>• Tempi di spedizione: 5-30 giorni</li>
                    <li>• Possibili costi doganali (sopra €150)</li>
                    <li>• Politiche di reso limitate</li>
                    <li>• Differenze minime nelle taglie (consultare tabella)</li>
                    <li>• Necessario un agent di shipping</li>
                    <li>• Pagamento tramite agent (non diretto)</li>
                  </ul>
                </div>
              </div>

              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">Termini Correlati e Concetti Importanti</h2>
              <div className="flex flex-wrap gap-2 mb-8">
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">Taobao</span>
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">Weidian</span>
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">QC Photos</span>
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">Marketplace Cinese</span>
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">Shipping Agent</span>
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">Product Sourcing</span>
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">Kaspreadsheet</span>
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">Prodotti Cinesi</span>
                <span className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-700">Shopping Internazionale</span>
              </div>

              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-10 mb-4">FAQ — Domande Frequenti su Itaobuy Spreadsheet</h2>
              <div className="space-y-4 mb-8">
                <div className="bg-background-100 rounded-xl p-5">
                  <h3 className="font-semibold text-foreground-900 mb-2">Serve un account per usare Itaobuy Spreadsheet?</h3>
                  <p className="text-sm text-foreground-600">No, Itaobuy Spreadsheet è completamente gratuito e accessibile a tutti. Basta visitare il nostro portale, scegliere una categoria e cliccare sul link per accedere allo spreadsheet su Kaspreadsheet. Non è richiesta alcuna registrazione per consultare i prodotti.</p>
                </div>
                <div className="bg-background-100 rounded-xl p-5">
                  <h3 className="font-semibold text-foreground-900 mb-2">Con quale frequenza viene aggiornato lo spreadsheet?</h3>
                  <p className="text-sm text-foreground-600">Lo spreadsheet viene aggiornato regolarmente, con nuovi prodotti aggiunti ogni settimana. I prezzi e la disponibilità vengono verificati almeno una volta al mese per garantire che le informazioni siano sempre accurate e aggiornate. L&apos;ultimo aggiornamento risale a Luglio 2026.</p>
                </div>
                <div className="bg-background-100 rounded-xl p-5">
                  <h3 className="font-semibold text-foreground-900 mb-2">Posso suggerire nuovi prodotti da aggiungere?</h3>
                  <p className="text-sm text-foreground-600">Certamente! La comunità di Itaobuy è sempre attiva e aperta ai suggerimenti. Se hai scoperto un prodotto interessante su Taobao o Weidian, puoi segnalarlo tramite il nostro sito principale Kaspreadsheet. Il team valuterà il prodotto e, se soddisfa i criteri di qualità, lo aggiungerà allo spreadsheet.</p>
                </div>
              </div>

              <div className="bg-primary-50 rounded-xl p-6 md:p-8 text-center mt-12">
                <h2 className="text-xl font-heading font-bold text-primary-800 mb-3">
                  Pronto a Iniziare il Tuo Shopping su Itaobuy?
                </h2>
                <p className="text-sm text-primary-700 mb-5 max-w-md mx-auto">
                  Esplora le nostre 14 categorie di prodotti verificati e scopri le migliori offerte dai marketplace cinesi.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="px-8 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                  >
                    itaobuy sheet
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                  <Link
                    to="/"
                    className="px-8 py-3 text-sm font-medium rounded-full border border-primary-300 text-primary-600 hover:bg-primary-100 transition-all whitespace-nowrap cursor-pointer"
                  >
                    Torna alla Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'Guida Completa a Itaobuy Spreadsheet: Come Trovare i Migliori Prodotti Cinesi nel 2026',
            description: 'Scopri cos\'è Itaobuy Spreadsheet, come funziona e come utilizzarlo per trovare i migliori prodotti dai marketplace cinesi. Guida completa in italiano con tabelle comparative, pro e contro, e FAQ.',
            author: {
              '@type': 'Organization',
              name: 'Itaobuy Spreadsheet Team',
            },
            datePublished: '2026-01-15',
            dateModified: '2026-07-14',
            inLanguage: 'it',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Serve un account per usare Itaobuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'No, Itaobuy Spreadsheet è completamente gratuito e accessibile a tutti. Basta visitare il nostro portale, scegliere una categoria e cliccare sul link per accedere allo spreadsheet su Kaspreadsheet. Non è richiesta alcuna registrazione per consultare i prodotti.',
                },
              },
              {
                '@type': 'Question',
                name: 'Con quale frequenza viene aggiornato lo spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Lo spreadsheet viene aggiornato regolarmente, con nuovi prodotti aggiunti ogni settimana. I prezzi e la disponibilità vengono verificati almeno una volta al mese per garantire che le informazioni siano sempre accurate e aggiornate. L\'ultimo aggiornamento risale a Luglio 2026.',
                },
              },
              {
                '@type': 'Question',
                name: 'Posso suggerire nuovi prodotti da aggiungere?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Certamente! La comunità di Itaobuy è sempre attiva e aperta ai suggerimenti. Se hai scoperto un prodotto interessante su Taobao o Weidian, puoi segnalarlo tramite il nostro sito principale Kaspreadsheet. Il team valuterà il prodotto e, se soddisfa i criteri di qualità, lo aggiungerà allo spreadsheet.',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}